import React from "react";

const Share = ({ ...props }) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33268 10H5.66602C4.56145 10 3.66602 10.8954 3.66602 12V19C3.66602 20.1046 4.56145 21 5.66602 21H16.3327C17.4372 21 18.3327 20.1046 18.3327 19V12C18.3327 10.8954 17.4373 10 16.3327 10H14.666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.9993 15.5V2M10.9993 2L6.41602 6M10.9993 2L15.5827 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Share;
